import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfoliostaffperformance',
  templateUrl: './portfoliostaffperformance.component.html',
  styleUrls: ['./portfoliostaffperformance.component.css']
})
export class PortfoliostaffperformanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
